import { PrestacionHistorico } from "../domain/entities/prestacionHistorico";
import { ProtocoloService } from "../domain/services/protocoloService";

export class GetHistoricos {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(
    ordenDeTrabajo: number,
    token: string
  ): Promise<PrestacionHistorico[]> {
    const colPrestaciones: PrestacionHistorico[] =
      await this.protocoloService.getPrestacionHistorico(ordenDeTrabajo, token);
    return colPrestaciones;
  }
}
